import {Spinner} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'

import React from 'react'

const LoadingContainer = styled.div`
    background: ${({theme}) => theme.colors.background.primary};
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    left: 0;
    top: 0;
    padding: ${(props) => props.theme.size.static150} 0;
    justify-content: center;
    z-index: 1;
`

export function Loading(): React.JSX.Element {
    return (
        <LoadingContainer>
            <Spinner variant="x-large" />
        </LoadingContainer>
    )
}
